"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.cn = void 0;
function cn(...args) {
    return args.filter((item) => Boolean(item)).join(' ');
}
exports.cn = cn;
//# sourceMappingURL=cn.js.map